<div class="modal fade" id="dialogLoteItemOrc" tabindex="-1" role="dialog"  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        Orçamentos de itens
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <h5 class="text-muted">{{item?.Produto}}</h5>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
              <i class="fa fa-plus"></i> Adicionar
            </button>
          </div>
        </div>
        <table class="table table-eddy table-sm">
          <thead>
            <tr>
              <th style="width: 35%" scope="col">Documento</th>
              <th style="width: 15%" scope="col">Valor Unit.</th>
              <th style="width: 10%" scope="col">Qtde</th>
              <th style="width: 10%" scope="col">Unidade</th>
              <th style="width: 15%" scope="col">Data</th>
              <th style="width: 15%" scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of item?.OrcamentoItemSim">
              <td style="width: 35%">
                <span *ngIf="!item.editavel && item.CPF">{{item.CPF | CPF}}</span>
                <span *ngIf="!item.editavel && item.CNPJ">{{item.CNPJ | CPF}}</span>
                <span *ngIf="!item.editavel && item.OutroDoc">{{item.OutroDoc}}</span>

                <select *ngIf="item.editavel" class="form-control col-4 float-left" [(ngModel)]="itemAtual.tipoDoc"
                  [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let item of opcoesDoc" [ngValue]="item">{{item}}</option>
                </select>
                <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'CPF'" type="text"
                  class="form-control col-8 float-right" [(ngModel)]="itemAtual.CPF"
                  [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}" unmask="true">
                <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'CNPJ'" type="text"
                  class="form-control col-8 float-right" [(ngModel)]="itemAtual.CNPJ"
                  [ngModelOptions]="{standalone: true}" [imask]="{mask: '00.000.000/0000-00'}" unmask="true">
                <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'OUTRO'" type="text"
                  class="form-control col-8 float-right" [(ngModel)]="itemAtual.OutroDoc"
                  [ngModelOptions]="{standalone: true}">
              </td>

              <td style="width: 15%">
                <span *ngIf="!item.editavel">{{item.ValorUnitario | number:'1.2-2'}}</span>
                <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.ValorUnitario"
                  [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
              </td>

              <td style="width: 10%">
                <span *ngIf="!item.editavel">{{item.Quantidade}}</span>
                <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.Quantidade"
                  [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
              </td>

              <td style="width: 10%">
                <span *ngIf="!item.editavel">{{item.UnidadeMedida}}</span>
                <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.UnidadeMedida"
                  [ngModelOptions]="{standalone: true}">
              </td>

              <td style="width: 15%">
                <span *ngIf="!item.editavel">{{item.DtOrcamento}}</span>
                <p-calendar (onFocus)="onFocusDate()"*ngIf="item.editavel" [(ngModel)]="itemAtual.DtOrcamento"
                  [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string"
                  dateFormat="dd/mm/yy" [showOnFocus]="true">
                </p-calendar>
              </td>

              <td style="width: 15%" class="text-right">
                <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
                <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
                </button>
                <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
                </button>
                <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>